// src/api/invoiceApi.js
import axiosClient from "./axiosClient";

const invoiceApi = {
  searchInvoices: (
    customerId,
    invoiceTemplateId,
    keyword,
    fromDate,
    toDate,
    page,
    pageSize,
    isNormal,
    invoiceStatus,
    fromAmount,
    toAmount,
    paymentMethod,
  ) => {
    const data = {
      customerId: customerId,
      invoiceTemplateId: invoiceTemplateId,
      fromDate: fromDate,
      toDate: toDate,
      keyword: keyword,
      pageNumber: page,
      pageSize: pageSize,
      isNormal: isNormal,
      invoiceStatus: invoiceStatus,
      fromAmount: fromAmount || null,
      toAmount: toAmount || null,
      paymentMethod: paymentMethod,
    };
    return axiosClient.post(`/invoices/search`, data, {
      withCredentials: true,
    });
  },

  upsertInvoice: (invoiceData, isApprove) => {
    invoiceData.isApprove = isApprove;
    return axiosClient.post("/invoices/upsert", invoiceData, {
      withCredentials: true,
    });
  },

  deleteInvoice: (id) => {
    return axiosClient.delete(`/invoices/${id}`, { withCredentials: true });
  },
  getInvoiceData: (reiId) => {
    const params = new URLSearchParams();
    if (reiId) params.append("reiId", reiId);
    return axiosClient.get(`/invoices/getInvoiceData?${params.toString()}`, {
      withCredentials: true,
    });
  },
  SearchTaxInfor: (taxId) => {
    return axiosClient.get(`/invoices/searchTaxInfor/${taxId}`, {
      withCredentials: true,
    });
  },
  syncInvoice: (reiId) => {
    const params = new URLSearchParams();
    params.append("reiId", reiId);
    return axiosClient.post(
      `/invoices/syncInvoice?${params.toString()}`,
      {},
      {
        withCredentials: true,
      },
    );
  },
  syncInvoices: (reiIds) => {
    const data = {
      reiIds: reiIds,
    };
    return axiosClient.post(`/invoices/syncInvoices`, data, {
      withCredentials: true,
      timeout: 60000,
    });
  },
  signInvoice: (reiIds) => {
    const data = {
      reiIds: reiIds,
    };
    return axiosClient.post(`/invoices/signInvoice`, data, {
      withCredentials: true,
    });
  },
  CheckExistChild: (reiId, status) => {
    const params = new URLSearchParams();
    params.append("reiId", reiId);
    params.append("status", status);
    return axiosClient.get(`/invoices/check-exist-child?${params.toString()}`, {
      withCredentials: true,
    });
  },
  getInvoiceInfor: (reiId) => {
    const params = new URLSearchParams();
    params.append("reiId", reiId);
    return axiosClient.get(`/invoices/getInvoiceInfor/${reiId}`, {
      withCredentials: true,
    });
  },
  getInvoicesInfor: (customerId, fromDate, toDate) => {
    return axiosClient.post(
      `/invoices/getInvoicesInfor`,
      {
        customerId: customerId,
        fromDate: fromDate,
        toDate: toDate,
      },
      {
        withCredentials: true,
        timeout: 60000,
      },
    );
  },
  approveInvoice: (reiId, isApprove) => {
    return axiosClient.put(
      `/invoices/approve-invoice`,
      {
        reiId: reiId,
        isApprove: isApprove,
      },
      {
        withCredentials: true,
      },
    );
  },
  removeInvoice: (ReiIds) => {
    return axiosClient.post(
      `/invoices/removeInvoice`,
      {
        ReiIds: ReiIds,
      },
      {
        withCredentials: true,
      },
    );
  },
  handleIssueCode: (ReiIds) => {
    return axiosClient.post(
      `/invoices/handleIssueCode`,
      {
        ReiIds: ReiIds,
      },
      {
        withCredentials: true,
      },
    );
  },
  handleExportInvoiceGuest: (buyerName, reiIds) => {
    return axiosClient.post(
      `/invoices/handleExportInvoiceGuest`,
      {
        buyerName: buyerName,
        reiIds: reiIds,
      },
      {
        withCredentials: true,
        timeout: 30000,
      },
    );
  },
  getInvoiceHistory: (reiId) => {
    return axiosClient.get(`/invoices/get-invoice-history/${reiId}`, {
      withCredentials: true,
    });
  },
  GetAllPaymentMethod: (customerId) => {
    return axiosClient.get(`/invoices/get-all-payment-method/${customerId}`, {
      withCredentials: true,
    });
  },
  getLinkUpdateInvoice: (reiId) => {
    return axiosClient.get(`/invoices/get-link-update-invoice/${reiId}`, {
      withCredentials: true,
    });
  },
  GetInvoiceSummaryReport: (
    isExport,
    fromDate,
    toDate,
    customerId,
    invoiceTemplateId,
    dateType,
  ) => {
    return axiosClient.post(
      `/invoices/get-invoice-summary-report`,
      {
        isExport: isExport,
        fromDate: fromDate,
        toDate: toDate,
        customerId: customerId,
        invoiceTemplateId: invoiceTemplateId,
        dateType: dateType,
      },
      {
        withCredentials: true,
        responseType: isExport ? "blob" : "json",
        timeout: 120000,
      },
    );
  },
  GetSalesRevenueReport: (
    isExport,
    fromDate,
    toDate,
    customerId,
    exportType,
    hasStorage,
    saveYear,
    saveQuarter,
  ) => {
    return axiosClient.post(
      `/invoices/get-sales-revenue-report`,
      {
        isExport: isExport,
        fromDate: fromDate,
        toDate: toDate,
        customerId: customerId,
        exportType: exportType,
        hasStorage: hasStorage,
        saveYear: saveYear,
        saveQuarter: saveQuarter,
      },
      {
        withCredentials: true,
        responseType: isExport ? "blob" : "json",
        timeout: 120000,
      },
    );
  },
  RecalculateTax: (year, quarter, customerId) => {
    return axiosClient.post(
      `/invoices/recalculate-tax`,
      {
        year: year,
        quarter: quarter,
        customerId: customerId,
      },
      {
        withCredentials: true,
      },
    );
  },
  getMemorandumAgreement: (reiId) => {
    return axiosClient.get(`/invoices/get-memorandum-agreement/${reiId}`, {
      withCredentials: true,
    });
  },
  SaveMemorandumAgreement: (data) => {
    return axiosClient.post(`/invoices/save-memorandum-agreement`, data, {
      withCredentials: true,
    });
  },
  exportFilterInvoiceToExcel: (
    customerId,
    invoiceTemplateId,
    keyword,
    fromDate,
    toDate,
    isNormal,
    invoiceStatus,
    fromAmount,
    toAmount,
    paymentMethod,
  ) => {
    const data = {
      customerId: customerId,
      invoiceTemplateId: invoiceTemplateId,
      fromDate: fromDate,
      toDate: toDate,
      keyword: keyword,
      isNormal: isNormal,
      invoiceStatus: invoiceStatus,
      fromAmount: fromAmount || null,
      toAmount: toAmount || null,
      paymentMethod: paymentMethod,
    };
    return axiosClient.post(`/invoices/export-filter-invoice-to-excel`, data, {
      withCredentials: true,
      responseType: "blob",
      timeout: 120000,
    });
  },
  createNewInvoice: (reiId) => {
    return axiosClient.post(`/invoices/create-new-invoice/${reiId}`, {
      withCredentials: true,
    });
  },
};

export default invoiceApi;
